<router-outlet [ngClass]="{'minDiv': device === ''}"></router-outlet>